import { TextArea, Form } from 'semantic-ui-react';
import { DangerButton, HoverBorderButton, MuteText } from '../../elements';
import { SkupremeModal } from '@components/index';
import { InventoryService, ToastMessage } from '@utility/index';
import { useState } from 'react';

export default function DeleteReasonPopup({
  open,
  onClose,
  onConfirm,
  reason,
  setReason,
  inventoryId,
}) {
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    if (!reason.trim() || loading) {
      return;
    }

    try {
      setLoading(true);
      await InventoryService.deleteInventory({
        inventoryIds: [inventoryId],
        reason: reason.trim(),
      });
      ToastMessage.success('Lot deleted successfully');
      onConfirm();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SkupremeModal title="Delete Inventory Lot" open={open} onClose={onClose} size="mini">
      <Form onSubmit={onSubmit}>
        <Form.Field>
          <MuteText>Reason for deletion</MuteText>
          <TextArea
            placeholder="Enter reason..."
            value={reason}
            onChange={e => setReason(e.target.value)}
          />
        </Form.Field>
        <div className="d-flex justify-content-end pt-2">
          <HoverBorderButton disabled={loading} onClick={onClose}>
            Cancel
          </HoverBorderButton>
          <DangerButton className="ml-2" disabled={!reason.trim()} loading={loading}>
            Delete
          </DangerButton>
        </div>
      </Form>
    </SkupremeModal>
  );
}
